import React from "react";
import {Modal, ModalHeader} from "reactstrap";
import Loader from "../../../components/Loader";
import CustomFieldsForm from "./customFieldsForm";

const CustomFieldModal = (props) => {
  const {data, open, onCancel} = props;

  return (
    <Modal backdrop={"static"} isOpen={open} size="lg" unmountOnClose={true}>
      <Loader />
      <ModalHeader>
        {data && data.id ? "Edit Custom Field" : "Add Custom Field"}
      </ModalHeader>
      <CustomFieldsForm data={data} onCancel={onCancel} />
    </Modal>
  );
};

export default CustomFieldModal;
